import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-6 offset-md-3" }
const _hoisted_2 = { class: "login-form mt-4 p-4" }
const _hoisted_3 = { class: "row g-3" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = {
  class: "form-check-label",
  for: "termsCheckbox"
}
const _hoisted_10 = { class: "col-12 error-placeholder" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = ["disabled"]

import { ref, computed, watch, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import ErrorLabel from "@/components/ui/ErrorLabel.vue";
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageError } from "@/plugins/ws";
import { useToast } from "@/composables/useToast";
import {RootState} from "@/store";

interface RegisterPayload {
  idUser: number;
  name: string;
  email: string;
  theme: string;
}

type RegisterSuccessMessage = WebSocketMessageWithFields<'auth-register', {
  idUser: number;
  name: string;
  email: string;
  theme: string;
}>;
type RegisterFailMessage = WebSocketMessageError<'auth-register-fail'>;

// Объединенный тип для всех сообщений
type RegisterWebSocketMessageType = RegisterSuccessMessage | RegisterFailMessage;


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ComponentsAuthRegister',
},
  __name: 'Register',
  emits: ["switchMode"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const store = useStore<RootState>();

// Типы для WebSocket сообщений компонента Register
const internalInstance = getCurrentInstance();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const wsSend = internalInstance?.appContext.config.globalProperties.$wsSend as (signal: string, payload: any) => void;

const email = ref('');
const name = ref('');
const password = ref('');
const termsAccepted = ref(false);
const latestMessageValue = ref(latestMessage);
const disabledSubmit = ref(false);

const theme = computed(() => store.state.theme.theme);

const setErrorReason = (reason: string) => store.dispatch('errorLabel/setErrorReason', reason);
const unsetErrorReason = () => store.dispatch('errorLabel/unsetErrorReason');

const { showToast } = useToast();

watch(email, () => {
  unsetErrorReason();
});

watch(name, () => {
  unsetErrorReason();
});

watch(password, () => {
  unsetErrorReason();
});

watch(termsAccepted, () => {
  unsetErrorReason();
});

// WebSocket message handler
const handleWebSocketMessage = (data: RegisterWebSocketMessageType): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'auth-register':
      signalRegister({
        idUser: data.idUser,
        name: data.name,
        email: data.email,
        theme: data.theme,
      });
      break;
    case 'auth-register-fail':
      signalRegisterFail(data.reason);
      break;
  }
};

watch(latestMessageValue, handleWebSocketMessage);

const handleClickActionRegister = () => {
  // Валидация checkbox
  if (!termsAccepted.value) {
    setErrorReason('Необходимо согласиться с условиями использования и политикой конфиденциальности');
    return;
  }

  // Очищаем ошибку если она была
  unsetErrorReason();

  wsSend('authRegister', {
    email: email.value,
    name: name.value,
    password: password.value,
    theme: theme.value,
  });
  disabledSubmit.value = true;
};

const handleClickModeRestore = () => {
  emit('switchMode', 'restore');
};

const handleClickModeLogin = () => {
  emit('switchMode', 'login');
};

const signalRegister = (payload: RegisterPayload) => {
  unsetErrorReason();
  disabledSubmit.value = false;
  store.dispatch('auth/wsSetUser', {
    idUser: payload.idUser,
    email: payload.email,
    name: payload.name,
    theme: payload.theme,
    admin: false,
    confirmEmail: false,
  });
  showToast('Регистрация успешна', 'Проверьте почту для подтверждения', 5000);
  emit('switchMode', 'registerCode');
};

const signalRegisterFail = (payload: string) => {
  setErrorReason(payload);
  disabledSubmit.value = false;
  showToast('Ошибка регистрации', payload, 15000);
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[11] || (_cache[11] = _createElementVNode("h4", null, "Регистрация в Хлебушке", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Почта", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            name: "email",
            class: "form-control",
            placeholder: "Email",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
          }, null, 512), [
            [_vModelText, email.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Имя", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "name",
            class: "form-control",
            placeholder: "Name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event))
          }, null, 512), [
            [_vModelText, name.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "Пароль", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            name: "password",
            class: "form-control",
            placeholder: "Password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event))
          }, null, 512), [
            [_vModelText, password.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "termsCheckbox",
              "data-testid": "terms-checkbox",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((termsAccepted).value = $event))
            }, null, 512), [
              [_vModelCheckbox, termsAccepted.value]
            ]),
            _createElementVNode("label", _hoisted_9, [
              _cache[9] || (_cache[9] = _createTextVNode(" Я согласен с ")),
              _createVNode(_component_router_link, {
                to: "/terms",
                target: "_blank",
                class: "text-decoration-none"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("условиями использования")
                ])),
                _: 1
              }),
              _cache[10] || (_cache[10] = _createTextVNode(" и ")),
              _createVNode(_component_router_link, {
                to: "/privacy",
                target: "_blank",
                class: "text-decoration-none"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("политикой конфиденциальности")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(ErrorLabel)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-dark float-end",
            onClick: handleClickActionRegister,
            disabled: disabledSubmit.value
          }, "Регистрация", 8, _hoisted_12)
        ])
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "mt-4" }, null, -1)),
      _createElementVNode("div", { class: "col-12 mode-switcher-placeholder" }, [
        _createElementVNode("p", { class: "text-center mb-0" }, [
          _cache[12] || (_cache[12] = _createTextVNode("Есть аккаунт? ")),
          _createElementVNode("a", {
            href: "#",
            onClick: handleClickModeRestore,
            "data-mode": "restore"
          }, "Восстановить"),
          _cache[13] || (_cache[13] = _createTextVNode()),
          _createElementVNode("a", {
            href: "#",
            onClick: handleClickModeLogin,
            "data-mode": "login"
          }, "Войти")
        ])
      ])
    ])
  ]))
}
}

})